import React, { useState, useEffect, useRef } from 'react';
import {IconButton} from "@material-ui/core";
import Alert from '@mui/material/Alert';
import ContentCopyIcon from '@mui/icons-material/ContentCopy';

export const RowCopia = ({titulo,link,versionPlana})=>{
    const [copiado,setCopiado]=React.useState(false);

    const copiarLink = async ()=>{
        try{
            const copy = await navigator.clipboard.writeText(link);
            setCopiado(true);
            setTimeout(() => {
                    setCopiado(false)
            }, 600);
        }catch(err){
            alert(err)
        }
    }

    if(versionPlana){
        return <div className="max-h-[200px] overflow-y-auto pr-2 mt-1"> 
            <div className='flex items-center justify-between'>
                <b>{titulo}</b>
                <div className="flex items-center gap-1">
                <IconButton className='text-sm' size='small' title='Copiar el link' onClick={copiarLink} aria-label="upload picture" component="label">
                    <ContentCopyIcon />
                </IconButton>
                {copiado && <p className='text-red-500 text-xs ml-1'>Link copiado</p>} 
                </div>
            </div>
            <div className="max-w-[300px] mt-1">
                <p className="break-all text-sm text-gray-600">{link}</p>
            </div>
        </div>
    }

    return  <tr>
    <td colSpan="2">
        <Alert severity="info" variant='outlined'>
                <b>{titulo}</b>
                <div style={{display:'flex',alignItems:'center',maxWidth:'300px'}}>
                        <p>{link}</p>
                    </div>
        </Alert>
    </td>
    <td>
        <IconButton title='Copiar el link' onClick={copiarLink}  aria-label="upload picture" component="label">
            <ContentCopyIcon />
        </IconButton>
         {copiado && <p className='color-red text-small'>Link copiado</p>} 
    </td>
</tr>
}


 

